export const ClassNames = {
  Card: "border rounded-sm shadow-sm p-4 flex flex-col min-h-48 space-y-10",
};
